import * as Yup from "yup";
import { validationsLocale } from "./ValidationsLocale";
import {CI_FREQUENCY_OPTIONS} from "./FormConfig.tsx";
import {__} from "@wordpress/i18n";

/**
 * Sets the Yup validation locale using predefined messages.
 * Ensures all validation errors follow Portuguese (Portugal) localization.
 */
Yup.setLocale(validationsLocale);

/**
 * Centralized validation messages (in pt-PT).
 * Used consistently across Yup schema definitions to maintain consistency and allow easy updates.
 */
const MESSAGES = {
  required: __("Este campo é de preenchimento obrigatório.", "df-simulators"),
  typeNumber: __("Este campo deve ser numérico.", "df-simulators"),
  positive: __("Este campo deve ser positivo.", "df-simulators"),
  min: __("Este campo deve ser maior que 1 euro.", "df-simulators"),
  oneOf: __("O valor selecionado é inválido.", "df-simulators"),
};

/**
 * Yup validation schemas for the Retirement Investment simulation form.
 * Ensures that all inputs respect domain-specific rules.
 *
 * Schema: `retirement_investment`
 */
export const validations: Record<string, Yup.ObjectSchema<any>> = {
  retirement_investment: Yup.object().shape({
    
    goal_amount: Yup.number()
      .required(MESSAGES.required)
      .typeError(MESSAGES.typeNumber)
      .positive(MESSAGES.positive)
      .min(1)
      .max(10000000),


    initial_investment: Yup.number()
      .typeError(MESSAGES.typeNumber)
      .min(0)
      .max(10000000),

    return_rate: Yup.number()
      .required(MESSAGES.required)
      .typeError(MESSAGES.typeNumber)
      .min(0)
      .max(30),

    investment_period_years: Yup.number()
      .required(MESSAGES.required)
      .typeError(MESSAGES.typeNumber)
      .positive(MESSAGES.positive)
      .max(50),

    have_compound_interest: Yup.string()
      .required(MESSAGES.required)
      .oneOf(["true", "false"], MESSAGES.oneOf),

    capitalization_frequency: Yup.string()
      .when('have_compound_interest', {
        is: 'true',
        then: (schema) => schema.required(MESSAGES.required)
          .oneOf(CI_FREQUENCY_OPTIONS.capitalization_frequency.map((option) => option.value), MESSAGES.oneOf),
        otherwise: (schema) => schema.notRequired()
      }),
  }),
};
